<template>
  <div>
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white text-center">
        {{ $t("approcheValeurs.header.title") }}
      </h2>
    </div>

    <section class="container mt-5">
      <!-- TITRE PRINCIPAL -->
      <div class="mb-5">
        <h2 class="fw-bold display-6 text-primary">
          {{ $t("approcheValeurs.main.title") }}
        </h2>

        <p
          class="mt-3 text-container"
          style="font-size: 1.15rem; line-height: 1.7"
        >
          <strong>{{ $t("approcheValeurs.main.block1.title") }}</strong
          ><br />
          {{ $t("approcheValeurs.main.block1.text") }}
        </p>

        <p class="mt-3" style="font-size: 1.15rem; line-height: 1.7">
          <strong>{{ $t("approcheValeurs.main.block2.title") }}</strong
          ><br />
          {{ $t("approcheValeurs.main.block2.lines.line1") }}<br />
          {{ $t("approcheValeurs.main.block2.lines.line2") }}<br />
          {{ $t("approcheValeurs.main.block2.lines.line3") }}<br />
          {{ $t("approcheValeurs.main.block2.lines.line4") }}
        </p>
      </div>
    </section>

    <!-- Nos valeurs fondamentales -->
    <div class="container">
      <h2 class="fw-bold text-center text-primary mt-5 mb-4">
        {{ $t("approcheValeurs.values.title") }}
      </h2>

      <p class="text-center">
        {{ $t("approcheValeurs.values.subtitle") }}
      </p>

      <div class="row g-4 d-flex justify-content-center">
        <!-- 2.1-->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-people"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card1.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card1.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card1.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card1.list.item3") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card1.list.item4") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.2-->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-chat-heart"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card2.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i
                  >{{ $t("approcheValeurs.values.cards.card2.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i
                  >{{ $t("approcheValeurs.values.cards.card2.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i
                  >{{ $t("approcheValeurs.values.cards.card2.list.item3") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.3 -->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-heart"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card3.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card3.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card3.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card3.list.item3") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.4-->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-stars"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card4.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card4.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card4.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card4.list.item3") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.5-->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-hand-thumbs-up"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card5.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card5.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card5.list.item2") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.6 -->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-journal-bookmark"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card6.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card6.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card6.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card6.list.item3") }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 2.7-->
        <div class="col-md-4">
          <div class="radiusborder shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-primary me-2 p-2"
                  ><i class="bi bi-lightbulb"></i
                ></span>
                <h5 class="fw-bold mb-0">
                  {{ $t("approcheValeurs.values.cards.card7.title") }}
                </h5>
              </div>
              <ul class="list-unstyled">
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card7.list.item1") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card7.list.item2") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card7.list.item3") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card7.list.item4") }}
                </li>
                <li>
                  <i class="bi bi-dot"></i>
                  {{ $t("approcheValeurs.values.cards.card7.list.item5") }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "ApprocheValeurs",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("approcheValeurs.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("approcheValeurs.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Cercle icône */
.icon-circle-template {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.6rem;
}

/* Box alignée verticalement (desktop) et empilée (mobile) */
.icon-box-template {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Gros texte (comme ta page) */
.text-large {
  font-size: 1.15rem;
  font-weight: 500;
}

/* Mobile : icône au-dessus du texte */
@media (max-width: 768px) {
  .icon-box-template {
    flex-direction: column;
    text-align: center;
  }

  .icon-circle-template {
    margin-bottom: 10px;
  }
}

/* Meilleure lisibilité */
li {
  font-size: 1.15rem;
}
</style>
